import { Dayjs } from 'dayjs';
import { Attribute, Debt, Product, ProductVersion, Staff, Status, Supplier, Warehouse } from 'models';
import { ImagePayload } from 'types';
import { Attachment } from './Supplier';
import { Transaction } from './Transaction';

export enum InventoryDocumentType {
  ORDER_SUPPLIER = 'order-supplier',
  PURCHASE_ORDER = 'purchase-order',
  RETURN_PURCHASE_ORDER = 'return-purchase-order',
  STOCK_OUT_ORDER = 'stock-out-order',
  INVENTORY_CHECK_ORDER = 'inventory-check-order',
}

export enum PaymentType {
  FULL_PAYMENT = 'full-payment',
  PARTIAL_PAYMENT_FIXED = 'partial-payment-fixed',
  PARTIAL_PAYMENT_FLEX = 'partial-payment-flex',
  NEGOTIATED_PAYMENT = 'negotiated-payment',
}
export interface BaseInventoryDocumentItem {
  id?: string;
  productVersionId: string;
  inventoryDocumentId?: string;
  productVersion?: ProductVersion;
  quantity: number;
  actualQuantity?: number;
  costPrice: number;
  salePrice?: number;
  total: number;
  name?: string;
  brand?: string;
  category?: string;
  productDimension?: string;
  sizeSpec?: string;
  color?: string;
  attributeId?: string;
  attributeName?: string;
  attributePrice?: number;
  attribute?: Attribute;
  unitId?: string;
  unit?: string;
  description?: string;
  unitConvertValue?: number;
  createdAt?: Date;
  updatedAt?: Date;
}
export interface InventoryDocumentItem extends BaseInventoryDocumentItem {
  id: string;
}
export interface BaseInventoryDocument {
  code: string;
  barcode?: string;
  isPublishing?: boolean;
  deliveryDate: string | Date | null;
  receivedDate?: string | Date | null;
  supplierId: string;
  description?: string;
  describeNote?: string;
  note?: string;
  warehouseId?: string;
  warehouse?: Warehouse;
  warehouseName?: string;
  userName: string;
  currentStep?: number;
  userPhoneNumber: string;
  userEmail?: string;
  statusId: string;
  status?: Status;
  paymentType?: PaymentType;
  total: number;
  payInAdvance?: number;
  paidMoney: number;
  unpaidMoney: number;
  approvedById?: string;
  appovedBy?: Staff;
  staffId?: string;
  staff?: Staff;
  taxId?: string;
  vat?: number;
  taxRate?: number;
  type?: InventoryDocumentType;
  stockOutReason?: StockOutOrderType;
  inventoryDocumentId?: string | null;
  inventoryDocument?: InventoryDocument;
  inventoryDocumentItemsId?: string[];
  inventoryDocumentItems?: BaseInventoryDocumentItem[];
  inventoryDocumentAttachments?: InventoryDocumentAttachment[];
  Transaction?: Transaction[];
  Debt?: Debt[];

  items: Product[];
  createdById?: string;
  createdBy?: Staff | null;
  supplier?: Supplier;
  createdAt?: Date;
  updatedAt?: Date;
}
export interface InventoryDocument extends BaseInventoryDocument {
  id: string;
  inventoryDocumentItems?: InventoryDocumentItem[];
}
export interface InventoryDocumentResponse {
  data: InventoryDocument;
  success: boolean;
}

export interface InventoryDocumentAttachment {
  id?: string;
  inventoryDocumentId?: string;
  attachmentId: string;
  attachment?: Attachment;
  description?: string;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date | null;
}
// 1. soo-draft (Bản nháp)
// 2. soo-wait-confirm (Đợi Duyệt Phiếu)
// 3. soo-confirm (Đã Duyệt Phiếu)
// 4. soo-exported (Đã xuất kho)
// 5. soo-cancel (Đã huỷ)
export enum StockOutOrderStatusCode {
  DRAFT = 'soo-draft',
  WAIT_CONFIRM = 'soo-wait-confirm',
  CONFIRMED = 'soo-confirm',
  EXPORTED = 'soo-exported',
  CANCELLED = 'soo-cancel',
}
export type StatusStockOutForCardStyles = 'DRAFT' | 'WAIT_CONFIRM' | 'CONFIRMED' | 'EXPORTED' | 'CANCELLED';
export const statusOutLabels: Record<StockOutOrderStatusCode, string> = {
  [StockOutOrderStatusCode.DRAFT]: 'Bản nháp',
  [StockOutOrderStatusCode.WAIT_CONFIRM]: 'Đợi duyệt phiếu',
  [StockOutOrderStatusCode.CONFIRMED]: 'Đã duyệt phiếu',
  [StockOutOrderStatusCode.EXPORTED]: 'Đã xuất kho',
  [StockOutOrderStatusCode.CANCELLED]: 'Phiếu bị từ chối',
};
export default InventoryDocument;
export enum StockOutOrderType {
  SALE = 'sale',
  PRODUCTION = 'production',
  TRANSFER = 'transfer',
  RETURN = 'return',
  WASTE = 'waste',
  SAMPLE = 'sample',
  OTHER = 'other',
}
export const stockOutOrderTypeLabels: Record<StockOutOrderType, string> = {
  [StockOutOrderType.SALE]: 'Xuất bán hàng',
  [StockOutOrderType.TRANSFER]: 'Xuất chuyển kho',
  [StockOutOrderType.PRODUCTION]: 'Xuất sản xuất',
  [StockOutOrderType.RETURN]: 'Xuất trả hàng',
  [StockOutOrderType.WASTE]: 'Xuất hàng hỏng',
  [StockOutOrderType.SAMPLE]: 'Xuất mẫu thử',
  [StockOutOrderType.OTHER]: 'Khác',
};
export interface StockOutOrderFilter {
  priceRange?: [number, number] | null;
  createdAt?: Dayjs;
  warehouseId?: string;
  status?: string | StockOutOrderStatusCode;
  stockOutOrderType?: StockOutOrderType;
  deliveryDate?: Dayjs;
  codeSearch?: string;
}

export interface StockOutFormData {
  code: string;
  exportDate: Dayjs;
  barcode: string;
  warehouse: string;
  warehouseId: string;
  exportReason: StockOutOrderType;
  approvedById: string;
  description?: string;
  images?: ImagePayload[];
}
